import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "manager-resident-cluster-modal__actions" }
const _hoisted_2 = ["disabled"]

import { computed, ref, watch } from 'vue';
import type { ManagerResidentsClusterOption } from './types';


export default /*@__PURE__*/_defineComponent({
  __name: 'ChangeClusterModal',
  props: {
    open: { type: Boolean },
    clusterId: {},
    clusters: {},
    saving: { type: Boolean }
  },
  emits: ["update:open", "select"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const draftClusterId = ref<string | undefined>(undefined);

const clusterOptions = computed(() =>
  props.clusters.map((cluster) => ({
    value: cluster.id,
    label: cluster.name,
  })),
);

const isSelectDisabled = computed(
  () => !draftClusterId.value || draftClusterId.value === props.clusterId,
);

watch(
  () => props.open,
  (isOpen) => {
    if (!isOpen) return;
    draftClusterId.value = props.clusterId || undefined;
  },
);

function handleSelect() {
  if (!draftClusterId.value || isSelectDisabled.value) return;
  emit('select', draftClusterId.value);
}

return (_ctx: any,_cache: any) => {
  const _component_a_divider = _resolveComponent("a-divider")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    open: __props.open,
    class: "manager-resident-cluster-modal",
    footer: null,
    closable: true,
    "mask-closable": true,
    centered: "",
    width: "480px",
    onCancel: _cache[2] || (_cache[2] = ($event: any) => (emit('update:open', false)))
  }, {
    default: _withCtx(() => [
      _cache[3] || (_cache[3] = _createElementVNode("h3", { class: "manager-resident-cluster-modal__title" }, "Изменить кластер", -1)),
      _cache[4] || (_cache[4] = _createElementVNode("p", { class: "manager-resident-cluster-modal__description" }, " Выберите кластер в который будет входить резидент. ", -1)),
      _createVNode(_component_a_divider, { class: "manager-resident-cluster-modal__divider" }),
      _createVNode(_component_a_form, {
        layout: "vertical",
        class: "manager-resident-cluster-modal__form"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_form_item, {
            label: "Кластер",
            class: "stc-ant-field-skin"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_select, {
                value: draftClusterId.value,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((draftClusterId).value = $event)),
                placeholder: "Выберите кластер",
                options: clusterOptions.value
              }, null, 8, ["value", "options"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_a_divider, { class: "manager-resident-cluster-modal__divider" }),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-secondary btn-medium",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('update:open', false)))
        }, " Отмена "),
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-primary btn-medium",
          disabled: isSelectDisabled.value || __props.saving,
          onClick: handleSelect
        }, _toDisplayString(__props.saving ? 'Сохранение...' : 'Выбрать'), 9, _hoisted_2)
      ])
    ]),
    _: 1
  }, 8, ["open"]))
}
}

})